import {useEffect, useRef} from 'react';
import {useEvent} from './use-event';

const ResetStatusTimeoutMs = 2000;

type Props = {
  reset: () => void;
  status: string;
};

export function useResetAfterRequestStatus({status, reset}: Props) {
  const stateTimeoutRef = useRef<ReturnType<typeof setTimeout>>();
  const handleReset = useEvent(reset);
  const isNotIdle = ['success', 'error'].includes(status);

  useEffect(() => {
    if (isNotIdle) {
      stateTimeoutRef.current = setTimeout(handleReset, ResetStatusTimeoutMs);

      return () => {
        clearTimeout(stateTimeoutRef.current);
      };
    }
  }, [handleReset, isNotIdle]);

  return {isNotIdle};
}
